EventTarget.prototype.addEvent = EventTarget.prototype.addEventListener;
EventTarget.prototype.removeEvent = EventTarget.prototype.removeEventListener;

Object.assign(NodeList.prototype, {
  removeClass: function() {
    for (const item of this) {
      item.classList.remove(...arguments);
    }
  },
  addClass: function() {
    for (const item of this) {
      item.classList.add(...arguments);
    }
  },
  addEvents: function(...args) {
    for (const item of this) {
      item.addEvent(...args);
    }
  },
  removeEvents: function(...args) {
    for (const item of this) {
      item.removeEvent(...args);
    }
  }
});
Object.assign(HTMLCollection.prototype, {
  removeClass: function() {
    for (const item of this) {
      item.classList.remove(...arguments);
    }
  },
  addClass: function() {
    for (const item of this) {
      item.classList.add(...arguments);
    }
  },
  addEvents: function(...args) {
    for (const item of this) {
      item.addEventListener(...args);
    }
  },
  removeEvents: function(...args) {
    for (const item of this) {
      item.removeEventListener(...args);
    }
  },
  forEach: Array.prototype.forEach
});
Object.assign(HTMLElement.prototype, {
  removeClass: function(...args) {
    this.classList.remove(...args);
  },
  addClass: function(...args) {
    this.classList.add(...args);
  },
  hasClass: function(className) {
    return this.classList.contains(className);
  }
});

Object.assign(String.prototype, {
  toCurrency: theme.moneyFormat,
  convertToSlug: function() {
    let str = this;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "");
    str = str.replace(/\u02C6|\u0306|\u031B/g, "");
    return str.toLowerCase().replace(/-/g, " ").trim().replace(/[\(\)\[\]'"]/g, "").replace(/[^\w]+/g, "-");
  }
});

const convertVehicleSelectorData = (vsData) =>
  (vsData || []).map((mk) => ({
    name: mk.t,
    field_2: (mk.m || []).map((md) => ({
      name: md.t,
      field_3: (md.y || []).map((yr) => ({ name: yr.t, url: yr.u }))
    }))
  }));

let cookie = {
  get: function(key) {
    try {
      var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return keyValue ? JSON.parse(keyValue[2]) : null;
    } catch (e) {
      return null;
    }
  },
  set: function(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1e3);
    document.cookie = key + "=" + JSON.stringify(value) + ";expires=" + expires.toUTCString() + ";path=/";
  },
  delete: function(key) {
    var keyValue = this.get(key);
    this.set(key, keyValue, "-1");
  }
};

window.AT = {
  cookie,
};


(() => {
    // app/scripts/filter.js
    const fieldItemName = (item) =>
      typeof item === "object" && item !== null && item.name != null ? item.name : item;

    var Filter = class {
      constructor(container) {
        let dataUrls = container.dataset.urls;
        this.collectionPosition = +container.dataset.collectionPosition;
        this.filterData = [];
        this.eventsBound = false;
        this.actionEventsBound = false;
        container._aoFilterInstance = this;
        this.elms = {
          container,
          field1: container.querySelector(".chosen-container[data-field-index='1']"),
          field2: container.querySelector(".chosen-container[data-field-index='2']"),
          field3: container.querySelector(".chosen-container[data-field-index='3']"),
          buttonSubmit: container.querySelector(".js-btn-submit"),
          buttonReset: container.querySelector(".js-btn-reset")
        };
        const filterSource = container.dataset.filterSource || "tag";
        this.filterSource = filterSource;
        this.dataUrls = dataUrls;
        this.start();
      }
      start() {
        this.loadFilterDataWithRetry(this.elms.container, this.filterSource, this.dataUrls)
          .then((data) => {
            this.filterData = Array.isArray(data) ? data : [];
            this.bootstrapFields(this.filterData);
          })
          .catch(() => {
            this.filterData = [];
            this.bootstrapFields([]);
          });
      }
      reload() {
        return this.start();
      }
      loadFilterDataWithRetry(container, filterSource, dataUrls, attempt = 0) {
        return this.loadFilterData(container, filterSource, dataUrls).then((data) => {
          if (data.length || filterSource !== "menu" || attempt >= 4) {
            return data;
          }
          return new Promise((resolve) => {
            window.setTimeout(() => {
              resolve(this.loadFilterDataWithRetry(container, filterSource, dataUrls, attempt + 1));
            }, 50 * (attempt + 1));
          });
        });
      }
      loadFilterData(container, filterSource, dataUrls) {
        const menuScript = container.querySelector("script.filter-mmy-data");
        if (menuScript) {
          try {
            return Promise.resolve(JSON.parse(menuScript.textContent));
          } catch (e) {
            /* fall through */
          }
        }
        if (filterSource === "menu") {
          const vsScript = document.querySelector("script.ao-vs-data");
          if (vsScript) {
            try {
              return Promise.resolve(convertVehicleSelectorData(JSON.parse(vsScript.textContent)));
            } catch (e) {
              /* fall through */
            }
          }
          return Promise.resolve([]);
        }
        if (dataUrls) {
          return this.getData(dataUrls)
            .then((data) => data.json())
            .then((data) => data.flat(2))
            .catch(() => []);
        }
        return Promise.resolve([]);
      }
      bootstrapFields(data) {
        data = Array.isArray(data) ? data : [];
        this.filterData = data;

        const finishInit = () => {
          this.initEventFieldTitle();
          if (!this.actionEventsBound) {
            this.actionEventsBound = true;
            this.initEventButtonReset();
            this.initEventButtonSubmit();
          }
        };

        let lastSelect = AT.cookie.get("arn-filter");
        if (!lastSelect || !(lastSelect instanceof Array)) {
          this.initField(this.elms.field1, data);
          finishInit();
          return;
        }

        let [field1Value, field2Value, field3Value] = lastSelect;
        if (!field1Value || !field2Value || !field3Value) {
          AT.cookie.delete("arn-filter");
          this.initField(this.elms.field1, data);
          finishInit();
          return;
        }

        let temporaryVariable = data.find(
          (item) => String(item.name).toLowerCase() == field1Value.toLowerCase()
        );
        if (!temporaryVariable) {
          AT.cookie.delete("arn-filter");
          this.initField(this.elms.field1, data);
          finishInit();
          return;
        }

        let data2 = temporaryVariable["field_2"];
        if (!data2 || !Array.isArray(data2)) {
          AT.cookie.delete("arn-filter");
          this.initField(this.elms.field1, data);
          finishInit();
          return;
        }
        temporaryVariable = data2.find(
          (item) => String(item.name).toLowerCase() == field2Value.toLowerCase()
        );
        if (!temporaryVariable) {
          AT.cookie.delete("arn-filter");
          this.initField(this.elms.field1, data);
          finishInit();
          return;
        }

        let data3 = temporaryVariable["field_3"];
        if (
          data2 &&
          data3 &&
          data3.some((a) => String(fieldItemName(a)).toLowerCase() == field3Value.toLowerCase())
        ) {
          this.setField(this.elms.field1, field1Value, data);
          this.setField(this.elms.field2, field2Value, data2);
          this.setField(this.elms.field3, field3Value, data3, true);
        } else {
          this.initField(this.elms.field1, data);
          AT.cookie.delete("arn-filter");
        }
        finishInit();
      }
      resetAll() {
        AT.cookie.delete("arn-filter");
        this.resetField(this.elms.field2);
        this.resetField(this.elms.field3);
        this.initField(this.elms.field1, this.filterData);
        this.elms.field1.addClass("active");
      }
      initField(element, data, lastField) {
        if (!Array.isArray(data)) {
          data = [];
        }
        let newData = lastField ? data.map((item) => fieldItemName(item)) : data.map((item) => item.name);
        let index = element.dataset.fieldIndex;
        let titleElement = element.querySelector(".js-title");
        let chosenResults = element.querySelector(".chosen-results");
        let chosenDrop = element.querySelector(".chosen-drop");
        chosenResults.innerHTML = "";
        data.forEach((item, i) => {
          let name = newData[i];
          let li = document.createElement("li");
          li.addClass("active-result");
          li.innerHTML = String(name).toUpperCase();
          li.setAttribute("data-value", name);
          if (lastField && typeof item === "object" && item !== null && item.url) {
            li.setAttribute("data-url", item.url);
          }
          chosenResults.append(li);
        });
        chosenResults.children.addEvents("click", (e) => {
          e.stopPropagation();
          let { target } = e;
          let value = target.dataset.value;
          titleElement.innerHTML = value;
          element.setAttribute("data-value", value);
          if (index === "3") {
            if (target.dataset.url) {
              element.setAttribute("data-collection-url", target.dataset.url);
            } else {
              element.removeAttribute("data-collection-url");
            }
          }
          chosenDrop.removeClass("active");
          this.change(index, data, value);
        });
      }
      setField(element, value, data, lastField) {
        this.initField(element, data, lastField);
        element.setAttribute("data-value", value);
        element.querySelector(".js-title").innerHTML = value.toUpperCase();
        if (lastField && data) {
          let hit = data.find(
            (item) => String(fieldItemName(item)).toLowerCase() === String(value).toLowerCase()
          );
          if (hit && typeof hit === "object" && hit.url) {
            element.setAttribute("data-collection-url", hit.url);
          }
        }
        element.addClass("active");
      }
      change(index, data, value) {
        let { field2, field3 } = this.elms;
        switch (index) {
          case "1": {
            let match = data.find((item) => String(item.name).toLowerCase() == value.toLowerCase());
            let newData = match && match.field_2;
            if (!newData || !newData.length) {
              return;
            }
            this.resetField(field2);
            this.resetField(field3);
            this.initField(field2, newData);
            field2.addClass("active");
            field2.querySelector(".chosen-drop").addClass("active");
            break;
          }
          case "2": {
            let match = data.find((item) => String(item.name).toLowerCase() == value.toLowerCase());
            let newData = match && match.field_3;
            if (!newData || !newData.length) {
              return;
            }
            this.resetField(field3);
            this.initField(field3, newData, true);
            field3.addClass("active");
            field3.querySelector(".chosen-single").click();
            break;
          }
          case "3":
            break;
        }
      }
      resetField(element) {
        let title = element.querySelector(".js-title");
        element.removeClass("active");
        title.innerHTML = title.dataset.placeholder;
        element.setAttribute("data-value", "");
        element.removeAttribute("data-collection-url");
        element.querySelector(".chosen-results").innerHTML = "";
      }
      initEventFieldTitle() {
        if (this.eventsBound) {
          return;
        }
        this.eventsBound = true;
        let { container } = this.elms;
        container.querySelectorAll(".chosen-container").forEach((fieldContainer) => {
          let filterTitle = fieldContainer.querySelector(".chosen-single");
          let inputSearch = fieldContainer.querySelector("input[name='search']");
          let fieldResults = fieldContainer.querySelector(".chosen-results");
          let target = filterTitle.nextElementSibling;
          filterTitle.addEvent("click", () => {
            if (target.hasClass("active")) {
              target.removeClass("active");
            } else {
              target.addClass("active");
            }
          });
          document.addEvent("click", (e) => {
            if (!filterTitle.parentElement.contains(e.target)) {
              target.removeClass("active");
            }
          });
          inputSearch.addEvent("input", () => {
            let value = inputSearch.value.toLowerCase();
            fieldResults.children.forEach((item) => {
              if (item.innerHTML.toLowerCase().includes(value)) {
                item.style.display = "block";
              } else {
                item.style.display = "none";
              }
            });
          });
        });
      }
      getData(urls) {
        // return Promise.all(urls.split(",").map((url) => fetch(url, { dataType: "json" })));
        return fetch(urls)
      }
      initEventButtonReset() {
        let { buttonReset } = this.elms;
        buttonReset.addEvent("click", () => {
          this.resetAll();
        });
      }
      initEventButtonSubmit() {
        let { buttonSubmit, field1, field2, field3 } = this.elms;
        buttonSubmit.addEvent("click", (e) => {
          let optionValues = this.getOptionValues();
          if (optionValues.filter(Boolean).length < 3) {
            switch (optionValues.filter(Boolean).length) {
              case 0:
                field1.querySelector(".chosen-drop").addClass("active");
                break;
              case 1:
                field2.querySelector(".chosen-drop").addClass("active");
                break;
              case 2:
                field3.querySelector(".chosen-drop").addClass("active");
                break;
            }
            e.stopPropagation();
            return;
          }
          let filterType = buttonSubmit.dataset.filterType || "tag";
          let yearUrl = field3.getAttribute("data-collection-url");
          let url =
            filterType === "menu" && yearUrl
              ? yearUrl
              : this.getFilterUrl(optionValues, filterType);
          AT.cookie.set("arn-filter", optionValues, 7);
          window.location.href = url;
        });
      }
      getFilterUrl(optionValues, type = "tag") {
        if (type == "tag")
          // return `${theme.routes.collectionsUrl}/${optionValues[this.collectionPosition].convertToSlug()}/${optionValues.map((i) => i.convertToSlug()).filter((i, index) => this.collectionPosition != index).join("+")}`;
          return `${theme.routes.collectionsUrl}/${optionValues[this.collectionPosition].convertToSlug()}`;
        let { container } = this.elms;
        const config = JSON.parse(container.querySelector('[name="filterAttribute"]').innerHTML);
        let url = [theme.routes.collectionsUrl];
        Object.values(config).forEach((attr, i) => {
          const value = attr == "collections" ? optionValues[i].convertToSlug() : `${attr}=${optionValues[i]}`;
          url.push(value);
        });
        return url.join("&").replace("&", "/").replace("&", "?");
      }
      getOptionValues() {
        let { field1, field2, field3 } = this.elms;
        return [`${field1.dataset.value}`, `${field2.dataset.value}`, `${field3.dataset.value}`];
      }
    };
    window.Filter = Filter;
})();
  